(function(){
    angular
        .module('appback')
        .directive('ngSocketcall', socketDir);
        socketDir.$inject = ['socket','$timeout'];
        function socketDir(socket,$timeout){
            return {
            	restrict: 'A',
        		replace: false,
	            //require: 'ngModel',
	            //templateUrl: '/backend/web/app/resultados/resultadoanalitica.html',
		        scope: {
                  //ngModel : '=',
                  item: '=',
              	},
              	scope:false,
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	//console.log(scope.item);
		            	var timeout;
		            	/*
	comentado de momento
		            	$(document).on("change",element.find('input,select,textarea'),function(){
		            		$timeout.cancel(timeout); //cancel the last timeout
    						timeout = $timeout(function(){
			            		//console.log("new",newvalue);
			            		//console.log("old",newvalue);
			            		//if(newvalue!=oldvalue && !scope.item.resultado.ignoreSocket){
		          					socket.emit('change:results', scope.item);
		          				//}
	          				}, 1500);
		            	})*/
		            	//element.find('input').on("")
		            	/*scope.$watch('item.resultado.extra',function(newvalue,oldvalue){
		            		$timeout.cancel(timeout); //cancel the last timeout
    						timeout = $timeout(function(){
			            		console.log("new",newvalue);
			            		console.log("old",newvalue);
			            		if(newvalue!=oldvalue && !scope.item.resultado.ignoreSocket){
		          					socket.emit('change:results', scope.item);
		          				}
	          				}, 1500);
		            		//console.log("CAMBIO SOCKET RES");
		            	},true)*/
		            	//console.log("EXISTO SOCKET");
		            	/*scope.$watch('item.resultado', function(newValue, oldValue) {
						    console.log("NUEVO RES", newValue);
						});*/
                        //console.log("anres",scope);
		            	//console.log("resultado");
			        });
		        }
          }
      }
})();